const state = {
    
    blocks:[
        {
            id:1,
            name:'',
            color:'#fff',
            columns:1,
            blockcomponents: {
                columns: [
                    //left column
                    [
                        {
                            id:1,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Name",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Bitte den Namen eingeben",
                                    icon:"edit",
                                    variable: 'name',
                                    setter: 'tags/TAG_SET_NAME',
                                    rules:"required"                                    
                            }
                        },
                                                                      
                    ],                   
                    [
                       
                                                                    
                        
                    ],                   
                ]
            }
        }
    ]

};

export default {
  namespaced: false,
  state,
  
};